export const GET_ALL_MENU_ITEMS = "/menu/list";
export const UPDATE_MENU_POST = "/menu/update";
